import { useState } from "react";
import { IonPage, IonContent } from "@ionic/react";
import { DatabaseZap } from "lucide-react";
import { invokeEdgeFunction } from "../../lib/supabase";
import { PageHeader } from "../../components/ui/PageHeader";
import { Button } from "../../components/ui/Button";
import { IconChip } from "../../components/ui/ListRow";

export default function DeveloperToolsPage() {
  const [isResetting, setIsResetting] = useState(false);

  const handleResetMockData = async () => {
    if (!confirm("This will delete ALL your current data and replace it with test data. Are you sure?")) {
      return;
    }
    setIsResetting(true);
    try {
      const response = await invokeEdgeFunction('reset-mock-data', {
        headers: { "Content-Type": "application/json" },
      });
      const result = await response.json();
      if (result.success) {
        alert(`Mock data reset successfully!\n\nCreated:\n${result.data.areas_created} areas\n${result.data.tasks_created} tasks\n${result.data.completions_created} completions`);
        window.location.reload();
      } else {
        alert(`Failed to reset data: ${result.message}`);
      }
    } catch (error) {
      console.error("Error resetting mock data:", error);
      alert("Error resetting data. Check console for details.");
    } finally {
      setIsResetting(false);
    }
  };

  return (
    <IonPage>
      <PageHeader title="Developer Tools" backHref="/settings" />
      <IonContent>
        <div className="max-w-lg mx-auto px-4 py-4 pb-28">
          <div className="card-surface p-5">
            <div className="flex items-start gap-3 mb-4">
              <IconChip tone="danger">
                <DatabaseZap className="w-5 h-5" />
              </IconChip>
              <div>
                <h2 className="font-bold text-foreground">Reset Mock Data</h2>
                <p className="text-sm text-muted-foreground">
                  Replace all your data with comprehensive test data.
                </p>
              </div>
            </div>
            <Button
              variant="danger"
              block
              onClick={handleResetMockData}
              loading={isResetting}
            >
              {isResetting ? "Resetting..." : "Reset to Mock Data"}
            </Button>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
